import React from 'react';
import { ListContextData, useListContext } from '../ListContext';
//@ts-ignore
import InfiniteScroll from 'react-infinite-scroller';
import Loading, { LoaderSize } from '../../ui/mui-builder/Loading/Loading';
import { Box } from '@mui/material';
import { useUiTheme } from 'framework/uiTheme';

const DEFAULT_LOAD_MORE_FUNCTION = () => {};

type DataGridInfiniteScrollPagingHandlerProps = {
  children: React.ReactElement;
};

const DataGridInfiniteScrollPagingHandler = ({ children }: DataGridInfiniteScrollPagingHandlerProps) => {
  const {
    loadNextPage = DEFAULT_LOAD_MORE_FUNCTION,
    hasMoreData = () => false,
    isLoadingPrevPage,
    isLoadingNextPage,
  } = useListContext() as ListContextData & {
    isLoadingPrevPage: boolean;
    isLoadingNextPage: boolean;
  };
  const { Loading: ThemedLoading = Loading } = useUiTheme();
  const loaderContainer = (
    <Box sx={{ position: 'relative', minHeight: '25px', marginTop: '12px' }}>
      <ThemedLoading size={LoaderSize.Medium} />
    </Box>
  );

  return (
    <InfiniteScroll
      pageStart={0}
      loadMore={loadNextPage}
      hasMore={hasMoreData()}
      initialLoad={false}
      useWindow
      loader={null}
      threshold={500}
    >
      {isLoadingPrevPage && loaderContainer}
      {React.cloneElement(children, { showPagination: false, showTotal: false })}
      {isLoadingNextPage && loaderContainer}
    </InfiniteScroll>
  );
};

export default DataGridInfiniteScrollPagingHandler;
